module.exports = __webpack_public_path__ + "img/download-icon-music.ac76f638.svg";